import type { RenderComponentProps } from "replo-runtime/shared/types";

import React, { useState } from "react";

import { useBundleBuilder } from "../BundleBuilderContext";
import { BundlePreview } from "./BundlePreview";

export const BundleFooter: React.FC<RenderComponentProps> = ({
  componentAttributes,
}) => {
  const {
    isSelectedThresholdMet,
    getBundleTotals,
    getEmptySlots,
    getBundleTotalQuantity,
  } = useBundleBuilder();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const emptySlots = getEmptySlots();
  const { total, savings } = getBundleTotals();
  const totalQuantity = getBundleTotalQuantity();

  return (
    <div
      {...componentAttributes}
      style={{
        backgroundColor: "white",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
        zIndex: 100,
        ...componentAttributes?.style,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
          borderTop: "1px solid #eee",
        }}
      >
        <div style={{ fontWeight: "600" }}>Subtotal: {total}</div>
        {totalQuantity > 0 && (
          <div
            style={{
              borderRadius: "4px",
              padding: "6px",
              color: "#059669",
              backgroundColor: "#ecfdf5",
            }}
          >
            You're saving {savings}
          </div>
        )}
      </div>

      <button
        style={{
          width: "100%",
          padding: "16px",
          backgroundColor: isSelectedThresholdMet() ? "#1E293B" : "#6b7280",
          color: "white",
          border: "none",
          borderRadius: "6px",
          fontWeight: "500",
          fontSize: "18px",
          margin: "0 16px 12px",
          cursor: isSelectedThresholdMet() ? "pointer" : "default",
          maxWidth: "calc(100% - 32px)",
        }}
      >
        {emptySlots > 0
          ? `Select ${emptySlots} More Items`
          : "Add Bundle To Cart"}
      </button>

      <button
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "0 16px 16px",
          border: "1px solid #e1e1e1",
          borderRadius: "6px",
          backgroundColor: "white",
          cursor: "pointer",
          width: "calc(100% - 32px)",
          fontWeight: "500",
        }}
        onClick={() => setIsPreviewOpen(!isPreviewOpen)}
      >
        {isPreviewOpen ? "Hide" : "Show"} Bundle Preview ({totalQuantity}){" "}
        {isPreviewOpen ? "▼" : "▲"}
      </button>

      <div
        style={{
          maxHeight: isPreviewOpen ? "300px" : "0",
          overflow: "hidden",
          transition: "max-height 0.3s ease",
        }}
      >
        <BundlePreview />
      </div>
    </div>
  );
};
